module.exports = __webpack_public_path__ + "gb-sct.svg?6231d4d57245374c7e7578275498310c";


//////////////////
// WEBPACK FOOTER
// ./node_modules/flag-icon-css/flags/1x1/gb-sct.svg
// module id = 1462
// module chunks = 0